import { ProductId, PromotionType } from "@okeys/shared-utils"
import { createSlice, PayloadAction } from "@reduxjs/toolkit"

export type XBoughtYFree = {
  X: number
  Y: number
  productsEligibles: ProductId[]
}

export type PriceDiscount = {
  newPrice: number
  productId?: ProductId
}

export type StatePromotion = {
  tempPromotion: {
    XBoughtYFree: XBoughtYFree
    priceDiscount: PriceDiscount
  }
  typePromotion: PromotionType
  errorPromotion: ErrorPromotion | null
}

export type ErrorPromotion =
  | "errorXYfields"
  | "errorsProducts"
  | "errorProduct"
  | "errorNewPrice"

const initialState: StatePromotion = {
  tempPromotion: {
    XBoughtYFree: {
      X: 1,
      Y: 1,
      productsEligibles: [],
    },
    priceDiscount: {
      newPrice: 0,
    },
  },
  typePromotion: "buyXGetYDiscount",
  errorPromotion: null,
}

export const promotionSlice = createSlice({
  name: "promotion",
  initialState: initialState,
  reducers: {
    setX: (state, action: PayloadAction<number>) => {
      if (state.typePromotion === "buyXGetYDiscount") {
        state.tempPromotion.XBoughtYFree.X = action.payload
        state.errorPromotion = null
      }
    },
    setY: (state, action: PayloadAction<number>) => {
      if (state.typePromotion === "buyXGetYDiscount") {
        state.tempPromotion.XBoughtYFree.Y = action.payload
        state.errorPromotion = null
      }
    },
    setProductsEligibles: (state, action: PayloadAction<ProductId[]>) => {
      if (state.typePromotion === "buyXGetYDiscount") {
        state.tempPromotion.XBoughtYFree.productsEligibles = action.payload
        state.errorPromotion = null
      }
    },
    setNewPrice: (state, action: PayloadAction<number>) => {
      if (state.typePromotion === "fixedPrice") {
        state.tempPromotion.priceDiscount.newPrice = action.payload
        state.errorPromotion = null
      }
    },
    setProductId: (state, action: PayloadAction<ProductId>) => {
      if (state.typePromotion === "fixedPrice") {
        state.tempPromotion.priceDiscount.productId = action.payload
        state.errorPromotion = null
      }
    },
    setTypePromotion: (state, action: PayloadAction<PromotionType>) => {
      state.typePromotion = action.payload
      state.errorPromotion = null
    },
    setErrorPromotion: (
      state,
      action: PayloadAction<ErrorPromotion | null>
    ) => {
      state.errorPromotion = action.payload
    },
  },
})

export const {
  setX,
  setY,
  setProductsEligibles,
  setNewPrice,
  setProductId,
  setTypePromotion,
  setErrorPromotion,
} = promotionSlice.actions
export default promotionSlice.reducer
